export async function checkMiniAppUpdateAndReload(): Promise<void> {
  // Telegram can keep the WebView alive between opens.
  // This check forces a hard reload when a new build is deployed.
  const localBuildId = typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : '';
  if (!localBuildId) return;

  try {
    const res = await fetch(`/version.txt?ts=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return;

    const remoteBuildId = (await res.text()).trim();
    if (!remoteBuildId || remoteBuildId === localBuildId) return;

    const url = new URL(window.location.href);
    // Prevent infinite loops if something odd happens.
    if (url.searchParams.get('v') === remoteBuildId) return;

    url.searchParams.set('v', remoteBuildId);
    window.location.replace(url.toString());
  } catch {
    // Ignore network errors.
  }
}
